/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index table to autogenerate all the components and extensions
 * Used by "prepareTables"
 */

import Table from './table/Table'
export * from './table/Table'
export default Table
